import { z } from 'zod';

import { ScenarioType } from '../../../types/scenario-modeling.types';
import { getTranslation } from '../../../utils/get-translation.util';

export const valuationFormSchema = z
  .object({
    preMoneyValuation: z.coerce
      .number({ message: getTranslation('PLEASE_ENTER_NUMERIC_VALUE') })
      .min(0, { message: getTranslation('THIS_DATA_IS_REQUIRED') })
      .optional(),
    date: z.coerce.date().optional(),
    type: z.enum(ScenarioType).optional(),
  })
  .refine(
    ({ date }) => {
      if (date) {
        return date.getTime() !== new Date(+0).getTime();
      }
      return true;
    },
    {
      message: getTranslation('INVALID_DATE'),
      path: ['date'],
    },
  );

export const safesFormSchema = z.object({
  safeItems: z.record(
    z.string(),
    z.object({
      id: z
        .string()
        .trim()
        .min(1, { message: getTranslation('REQUIRED') }),
      safeId: z
        .string()
        .trim()
        .min(1, { message: getTranslation('REQUIRED') }),
      shareClass: z.object({
        name: z
          .string()
          .trim()
          .min(1, { message: getTranslation('REQUIRED') }),
        id: z
          .string()
          .trim()
          .min(1, { message: getTranslation('REQUIRED') }),
      }),
    }),
  ),
});

export const grantsFormSchema = z.object({
  exercise: z.boolean().optional(),
  grantItems: z
    .array(
      z.object({
        id: z
          .string()
          .trim()
          .min(1, { message: getTranslation('REQUIRED') }),
        vestingTaskId: z
          .string()
          .trim()
          .min(1, { message: getTranslation('REQUIRED') }),
        issuedShares: z.coerce
          .number({ message: getTranslation('PLEASE_ENTER_NUMERIC_VALUE') })
          .min(1, { message: getTranslation('REQUIRED') }),
      }),
    )
    .optional(),
});

export const sarsFormSchema = z.object({
  exercise: z.boolean().optional(),
  payout: z.boolean().optional(),
  sarItems: z
    .array(
      z.object({
        id: z
          .string()
          .trim()
          .min(1, { message: getTranslation('REQUIRED') }),
        grantId: z
          .string()
          .trim()
          .min(1, { message: getTranslation('REQUIRED') }),
        issuedShares: z.coerce
          .number({ message: getTranslation('PLEASE_ENTER_NUMERIC_VALUE') })
          .optional(),
        payout: z.coerce
          .number({ message: getTranslation('PLEASE_ENTER_NUMERIC_VALUE') })
          .optional(),
      }),
    )
    .optional(),
});
